import React, { useContext, useMemo } from 'react';

import { MenuItem } from '@mui/material';
import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';
import { getSortName } from '../../utils/sortingUtils';
import { getDisplayName } from '../../utils/student';
import Select from '../forms/Select';

const StyledSelect = styled(Select)`
    min-width: 250px;

    &.Mui-focused {
        background-color: rgba(0, 0, 255, 0.1);
    }
`;

export interface ClassSessionSelectProps {
    onChange: (e) => void;
}

const ClassStudentSelect: React.FC<ClassSessionSelectProps> = ({ onChange }) => {
    const { t, students, studentId } = useContext(AttendanceContext);

    const sortedStudents = useMemo(
        () =>
            students.sort((a, b) => {
                const textA = getSortName(a);
                const textB = getSortName(b);
                return textA.localeCompare(textB);
            }),
        [students]
    );

    if (!studentId) return null;

    return (
        <StyledSelect defaultValue={studentId} name={'student'} value={studentId} onChange={onChange}>
            <MenuItem key={0} value={'session-summary'}>
                {t('session-summary')}
            </MenuItem>
            <MenuItem key={1} value={'student-summary'}>
                {t('student-summary')}
            </MenuItem>

            {sortedStudents.map((student, i) => (
                <MenuItem key={i + 2} value={student.student_id}>
                    {getDisplayName(student)}
                </MenuItem>
            ))}
        </StyledSelect>
    );
};

export default ClassStudentSelect;
